import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import BoxSection from '../Layout/BoxSection'

import AttachedFilesBox from '../Shared/AttachedFilesBox'

import ModalSelectorFromList from '../Shared/ModalSelectorFromList'
import SelectorInput from '../Shared/SelectorInput'


import { isAllowedToViewComponent } from '../../utils/helpers';

import { 
    showModalSelector, 
    selectFromSelector,
} from '../../actions/common'


import {
    getSolicitud
} from '../../actions/contratoanual'


class General extends Component {

    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_CONTRATOANUAL1', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/auxiliares', fn)
    }



	render() {


        const { id, contratoanual } = this.props
        if (!id) return null

        const documento = contratoanual.getIn(['documentos', 0]);



        
        return ( 
        <Fragment>

            <BoxSection title="Información básica">

                <div className="row">

                    <div className="col-md-4">
                        <div className="form-group">
                            <label className="control-label">Solicitante</label>
                            <input type="text" value={ contratoanual.getIn(['solicitante', 'fullname']) || '' } className="form-control input-sm" disabled/>
                        </div>
                    </div>


                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Correo</label>
                            <input type="text" value={ contratoanual.getIn(['solicitante', 'email']) || '' } className="form-control input-sm" disabled/>
                        </div>
                    </div>


                    <div className="col-md-1">
                        <div className="form-group">
                            <label className="control-label">Extensión</label>
                            <input type="text" value={ contratoanual.getIn(['solicitante', 'extension']) || '' } className="form-control input-sm" disabled/>
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Área</label>
                            <input type="text" value={ contratoanual.getIn(['solicitante', 'area', 'nombre']) || '' } className="form-control input-sm" disabled/>
                        </div>
                    </div>

                </div> 

                <div className="row">


                    {
                        isAllowedToViewComponent('administrador', contratoanual.get('responsable_compras')) && contratoanual.get('estado') != 0 && contratoanual.get('estado') != 7 ? (

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Responsable de compras</label>
                                    <SelectorInput value={ contratoanual.getIn(['responsable_compras', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`solicitud.responsable_compras`) } onReset={ () => this.props.updateInputs(`solicitud.responsable_compras`, null) } />
                                </div>
                            </div>

                        ):(

                            <div className="col-md-4">
                                <div className="form-group">
                                    <label className="control-label">Responsable de compras</label>
                                    <input className="form-control input-sm" type="text" value={ contratoanual.getIn(['responsable_compras', 'fullname']) || '' } disabled/>
                                </div>
                            </div>
                        )
                    }

                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Correo</label>
                            <input className="form-control input-sm" value={ contratoanual.getIn(['responsable_compras', 'email']) || '' } disabled />
                        </div>
                    </div>

                    <div className="col-md-1">
                        <div className="form-group">
                            <label className="control-label">Extensión</label>
                            <input className="form-control input-sm" type="text" value={ contratoanual.getIn(['responsable_compras', 'extension']) || '' }  disabled/>
                        </div>
                    </div>


                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Fecha solicitud</label>
                            <input className="form-control input-sm" value={ moment(contratoanual.get('created_at')).format('DD/MM/YYYY') || '' } disabled />
                        </div>
                    </div>


                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">No. Solicitud</label>
                            <input className="form-control input-sm" value={ contratoanual.get('id') || '' } disabled />
                        </div>
                    </div>                 
                
                
                </div>
                
                                                   

            </BoxSection>

            <div className="separator"></div>

            <BoxSection title="Datos del contrato">

                <div className="row">

                    <div className="col-md-8">
                        <div className="form-group">
                            <label className="control-label">Tipo de servicio a desarrollar</label>
                            <input type="text" value={ contratoanual.get('proyecto_evento') || '' } className="form-control input-sm" disabled />
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Inicio del contrato</label>
                            <input type="text" value={ moment(documento.get('fecha_inicio')).format('DD/MM/YYYY')  || '' }  className="form-control input-sm" disabled />
                        </div>
                    </div>

                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Terminación del contrato</label>
                            <input type="text" value={ moment(documento.get('fecha_entrega')).format('DD/MM/YYYY')  || '' }  className="form-control input-sm" disabled />
                        </div>
                    </div>

                </div>


            </BoxSection>

            <div className="separator"></div>


            <BoxSection title="Datos del proveedor/contratista">
                <div className="row">
                    <div className="col-md-4">
                        <div className="form-group">
                            <label className="control-label">Nombre de razón social</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'nombre']) || '' } className="form-control input-sm" disabled={ true } />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">Nit</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'identificacion']) || '' } className="form-control input-sm" disabled={ true } />
                        </div>
                    </div>                                        
                    <div className="col-md-4">
                        <div className="form-group">
                            <label className="control-label">Nombre del representante legal</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'representante']) || '' } className="form-control input-sm" disabled={ true } />
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div className="form-group">
                            <label className="control-label">C.C. del representante legal</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'cc_representante']) || '' } className="form-control input-sm" disabled={ true } />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Persona de contacto</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'contacto']) || '' } className="form-control input-sm" disabled={ true } />
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Cargo</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'cargo']) || '' } className="form-control input-sm" disabled={ true }/>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Correo electrónico</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'correo']) || '' } className="form-control input-sm" disabled={ true }/>
                        </div>
                    </div>
                    <div className="col-md-3">
                        <div className="form-group">
                            <label className="control-label">Celular/Teléfono</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'telefono']) || '' } className="form-control input-sm" disabled={ true }/>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <label className="control-label">Dirección para envío de notificaciones</label>
                            <input type="text" value={ documento.getIn(['proveedore', 'direccion']) || '' } className="form-control input-sm" disabled={ true }/>
                        </div>
                    </div>
                </div>
            </BoxSection>

            <div className="separator"></div>

            <BoxSection title="Observaciones">
                <div className="row">
                    <div className="col-md-12">
                        <div className="form-group">
                            <textarea type="text" className="form-control input-sm" rows={4} value={ contratoanual.get('observaciones') || '' } disabled />
                        </div>
                    </div>
                </div>                
            </BoxSection>

            <div className="separator"></div>

            <AttachedFilesBox
                files={ contratoanual.get('adjuntos') }
                root='solicitud'
                removeFiles = { this.props.removeFiles }
                updateInputs = { this.props.updateInputs }
                obj={ contratoanual }
                check={ 'solicitud' }
                disabledAttach
            />


            <ModalSelectorFromList />

 
        </Fragment> 
        )
	}
}

function mapStateToProps(state) {
    return {
        id: state.contratoanual.get('id'),
        contratoanual: state.contratoanual.get('solicitud'),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getSolicitud: (id) => dispatch(getSolicitud(id)),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(General)


// WEBPACK FOOTER //
// ./src/components/ContratoAnual/General.jsx